module.exports = "pegasus_template/assets/tech/basic_1/1.png";